export default __webpack_public_path__ + "static/media/dendro.cc9c434a.png";